// import { Background } from './../../games/crash/gameelements/Background';
// ./config/themes/index.ts

// 1. Define the structure for all themes
export interface Theme {
  colors: {
    background: string;
    background2: string;
    background3?: string;
    background4: string;
    slider: string;
    text2: string;
    stake: string;
    autoplayBtBgborder: string;

    //  autoplayBgHoverborder:string;
    qbet: string;
    primary: string;
    secondary: string;
    text: string;
    warning?: string;
    success?: string;
    danger?: string;
    overlay?: string;
    border?: string;
    betIdle?: string;
    betCancel?: string;
    betCashout?: string;
    betborder: string;
    betborderPress: string;
    betbutton: string;
    cancelborder?: string;
    cashoutborder?: string;
    betHover: string;
    betButtonHover: string;
    betCancelPressMobile: string;
    betButtonPressMobile: string;
    betCashPressMobile: string;
    betButtonPress: string;
    betCancelHover: string;
    betCashHover: string;
    betCashPress: string;
    betCancelPress: string;
    betCancelShadow?: string; // default (non-pressed) box-shadow for cancel button
    // StartPress: string;
    // CancelBorderPress: string;
    // CashoutBorderPress: string;

    // 👇 Multiplier-specific tokens
    multiplierHigh?: string; // ≥ 10x
    multiplierMedium?: string; // ≥ 5x
    multiplierLow?: string; // ≥ 2x
    multiplierBase?: string; // < 2x
    msgBg?: string;
    autoplayBtBg?: string;
    autoplayBgHover?: string;
  };
  fonts: {
    primary: string;
    secondary: string;
    button?: string;
  };
  uiElements: {
    button: { borderRadius: string; padding: string; fontSize: string };
    card: { borderRadius: string; shadow: string };
    modal: { borderRadius: string; background: string };
    spacing?: { padding: string; margin: string };
  };
}

// 2. Define all available theme names
export type ThemeName =
  | 'crash'
  | 'piratesFortune'
  | 'eyeOfTheReels'
  | 'predatorPath'
  | 'slot'
  | 'adventure'
  | 'skyx'
  | 'skyxNew'
  | 'crashAlt'
  | 'skysniffer';

// 3. Create a registry of dynamic importers for lazy loading
export const themeLoaders: Record<
  ThemeName,
  () => Promise<{ default: Theme }>
> = {
  crash: () => import('@config/themes/crash.theme'),
  piratesFortune: () =>
    import('@config/themes/games/slots/piratesfortune.theme'),
  eyeOfTheReels: () => import('@config/themes/games/slots/eyeofthereels.theme'),
  predatorPath: () =>
    import('@config/themes/games/adventure/predatorpath.theme'),
  slot: () => import('@config/themes/slot.theme'),
  adventure: () => import('@config/themes/adventure.theme'),
  skyx: () => import('@config/themes/games/crash/skyx.theme'),
  skyxNew: () => import('@config/themes/games/crash/skyx_new.theme'),
  crashAlt: () => import('@config/themes/games/crash/crash_alt.theme'),
  skysniffer: () => import('@config/themes/games/crash/skysniffer.theme'),
};
